<template>
    <div>
		<div>
			<b-row>
				<b-col cols="3">
					<b-form-select
						size="sm"
						v-model="selected"
						:options="items"
						value-field="id"
						text-field="name"
					>
						<template slot="first">
							<option :value="null" :disabled="items.length === 1">-- {{ $t('All') }} --</option>
						</template>
					</b-form-select>
				</b-col>
			</b-row>
		</div>
		<hr>
	</div>
</template>

<script>
    import ReferencesService from "../../../../services/references.sevice";

	export default {
        name: 'FilterGoods',

		data() {
        	return {
        		selected: null,
				items: [],
				arrLen: 1,
			}
		},

		methods: {
			async loadCategory() {
				await ReferencesService.getReferenceChildren(`WAREHOUSE_CATEGORY`).then(response => {
					this.items = response.data;

				})
			},
			async checkDefault(){
				if(this.items.length === 1){
					this.selected = this.items[0].id
				}else{
					this.selected = (localStorage.getItem('defaultCategory')) ? localStorage.getItem('defaultCategory') : null;
				}
			},
		},

		async created() {
        	await this.loadCategory();
			await this.checkDefault()

		},

		watch: {
        	selected: {
        		handler(newValue) {
        			localStorage.setItem('defaultCategory', newValue);
        			if (!newValue) {
        				localStorage.removeItem('defaultCategory');
						this.$emit('selected', []);
        				return false;
        			}
        			this.$emit('selected', [{
        				field: 'category.id',
						value: newValue,
						option: 'EQUALS',
						type: 'long'
					}]);
				}
			}
		}
	}
</script>

<style scoped>

</style>
